import QueriesLimitTable from '@/components/API/QueriesLimitTable';
import SwaggerAPI from '@/components/API/SwaggerAPI';

export default function InteractiveConsole() {
  return (
    <div>
      <p>
        In order to easily and interactively query the REST endpoints of DISGENET as well as to get a detailed
        description of the input parameters and response format of each single endpoint, you can access the
        REST API interactive documentation. To be able to query endpoints, users of the REST API interactive
        documentation need to provide their API key by clicking the "Authorize" button (top-right corner, next
        to the green padlock symbol). A popup box named "Available authorizations" will open enabling users to
        copy their API key in the input box and click on the "Authorize" button. From now on all the API calls
        generated by the REST API interactive documentation will be automatically authorized by means of the
        provided API key.
      </p>
      <div>
        <QueriesLimitTable />
        <SwaggerAPI />
      </div>
    </div>
  );
}
